import type {
  BaseFormExposeRef,
  BaseFormProps,
} from '@/pages/CustomCenter/ExtractConfig/components/workflow/types';
import type { FormValue } from '@/pages/CustomCenter/ExtractConfig/components';
import {
  TableForm as InnerTableForm,
  NewTableForm,
} from '@/pages/CustomCenter/ExtractConfig/components';
import type { ITableTag, ITag } from '@/services/custom/type';
import { Form } from 'antd';
import { tryit } from 'radash';
import type { ForwardRefRenderFunction } from 'react';
import { forwardRef, useImperativeHandle } from 'react';
import useExtractTags from '../../../components/extract-tag-select/use-extract-tags';

const { useForm } = Form;

export const TableForm: ForwardRefRenderFunction<
  BaseFormExposeRef<{ form: FormValue }>,
  BaseFormProps<FormValue>
> = (props, ref) => {
  // props
  const { initialValue, readonly } = props;
  // form
  const [form] = useForm<FormValue>();
  // tags
  const { extractTags } = useExtractTags();
  // imperative handle
  useImperativeHandle(ref, () => ({
    assembleForm: async () => {
      const [err, values] = await tryit(form.validateFields)();

      if (err) return;

      return {
        form: {
          ...values,
        },
      };
    },
  }));

  return (
    <NewTableForm
      form={form}
      initialValues={initialValue}
      // readonly={readonly || false}
    />
    // <InnerTableForm
    //   form={form}
    //   fields={
    //     extractTags ||
    //     ({ text_tags: [], table_tags: [] } as {
    //       text_tags: ITag[];
    //       table_tags: ITableTag[];
    //     })
    //   }
    //   initialValues={initialValue}
    //   readonly={readonly}
    // />
  );
};

export default forwardRef(TableForm);
